import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px',
    padding: '1px 6px',
    borderRadius: '10px',
    border: '1px solid #9aa8d6', // unavailable as design token
    color: '#3d4b8f', // unavailable as design token
    backgroundColor: '#eef2ff', // unavailable as design token
    flexShrink: 0
  },
  text: {
    fontSize: '11px',
    fontWeight: 700,
    paddingBottom: '0px',
    textTransform: 'none',
    color: capitalDesignTokens.semanticColors.foreground.secondary
  }
});
